import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import useErrorStore, { setErrorActionSelector } from 'Core/stores/error';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import { get } from 'Core/utils/api';
import { useNavigate } from 'react-location';
import { errorPath } from 'Core/routes';

export function useGetDepositOptions() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const setError = useErrorStore(setErrorActionSelector);

  return useQuery(cacheKeys.depositOptions, () => get('/api/deposit-options'), {
    onError(e) {
      if (e) {
        setError(t('status.error.getDepositOptionsFailed') + e.message);
        navigate({ to: errorPath });
      }
    },
  });
}
